<template>
    <div class="container nopadding">
        <div class="wrapper">
            <div class="header"><h1>{{ $t('ordine_titolo') }}</h1></div>
            <div class="content text-center" style="min-height:560px;">
                <div class="title">{{ $t('ordine_scelta_titolo') }}</div>
                <lv1 v-if="this.conf_lv1"
                     :init-type="this.init_type"
                     :configurazioni="this.conf_lv1"
                     :curr-type="this.curr_type"
                     :address="this.curr_address"
                     :point="this.curr_point"
                     :table="this.curr_table"
                     @onButtonPress="this.onLv1ButtonPress"
                     @onIndirizzoManualeCittaPicked="this.onIndirizzoManualeCittaPicked"
                     @onIndirizzoManualeZonaPicked="this.onIndirizzoManualeZonaPicked"
                     @onIndirizzoCoordinatePicked="this.onIndirizzoCoordinatePicked"
                     @onPointPicked="this.onPointPicked"
                     @onQrCodeDecoded="this.onQrCodeDecoded"
                     @onQrCodeScanAgain="this.onQrCodeScanAgain"
                />
                <lv2 v-if="this.conf_lv2"
                     :init-people-number="this.init_people_number"
                     :init-day="this.init_day"
                     :configurazione="this.conf_lv2"
                     :curr-type="this.curr_type"
                     :numero-persone="this.conf_lv1.mangia_ristorante.numero_persone"
                     @onPeopleNumberChange="this.onPeopleNumberChange"
                     @onDayChange="this.onDayChange"
                />
                <lv3 v-if="this.conf_lv3"
                     :configurazione="this.conf_lv3"
                     :init-time="this.init_time"
                     :curr-type="this.curr_type"
                     @onTimeChange="this.onTimeChange"
                />
                <lv-final
                    v-if="this.conf_lv3 && this.conf_lv3.hours.length"
                    :curr-type="this.curr_type"
                    :f-asap="!!this.conf_lv1[this.curr_type].f_appena_possibile"
                    :curr-asap="this.curr_asap"
                    @onAsapChange="this.onAsapChange"
                    @onSeeMenuTap="this.onSeeMenuTap"
                />
                <div class="w-100 p-4" v-if="this.curr_status">
                    <h5>{{ this.curr_status }}</h5>
                </div>
                <div class="spinner-border pb-3" role="status" v-if="this.loading_visible">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <modal-confirm :header-title="$t('attenzione_label')"
                       :body-text="'Continuando i prodotti a carrello potrebbero essere rimossi. Procedere?'"
                       v-if="this.show_confirm_modal"
                       @close="onModalClose"
        />
    </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import moment from "moment";

import Lv1 from "./partials/options/Lv1";
import Lv2 from "./partials/options/Lv2";
import Lv3 from "./partials/options/Lv3";
import LvFinal from "./partials/options/LvFinal";

import {lv1 as getLv1, lv2 as getLv2, lv3 as getLv3} from "../../api/restaurant/shifts";
import {getSurvivedItems, trovaConsegnaCitta, trovaConsegneCitta} from "../../libraries/utils";
import ModalConfirm from "../partials/ModalConfirm";


export default {
    name: "Options",
    components: {ModalConfirm, LvFinal, Lv3, Lv1, Lv2},
    data() {
        return {
            curr_address: null,
            init_type: null,
            init_people_number: null,
            init_day: null,
            init_time: null,
            conf_lv1: null,
            conf_lv2: null,
            conf_lv3: null,
            loading: true,
            curr_type: null,
            curr_people_number: null,
            curr_date: null,
            curr_time: null,
            curr_asap: null,
            curr_point: null,
            curr_table: null,
            show_confirm_modal: false
        }
    },
    created() {
        this.curr_address = this.order.address;
        this.curr_asap = this.order.f_appena_possibile;
        this.curr_type = this.order.type;
        this.curr_point = this.order.id_punto_di_servizio;
        this.curr_table = this.order.table;
        this.fetch();
    },
    computed: {
        curr_status: function () {
            const currentConf = this.conf_lv1 ? this.conf_lv1[this.curr_type] : null;
            if (!currentConf) {
                return this.$t('select_order_type');
            } else if (currentConf.f_forza_blocco || !currentConf.f_attivo) {
                return this.$t('ordine.bloccati_msg');
            }
        },
        f_ponyu_fasce_delivery: function () {
            return !!(this.locale.ponyu_api_key &&
                this.locale.f_ponyu_fasce_delivery
            );
        },
        f_eatintime_fasce_delivery: function () {
            return !!(this.locale.eatintime_api_key &&
                this.locale.f_eatintime_fasce_delivery
            );
        },
        ...mapState('localization', {
            language: (state) => state.language
        }),
        ...mapState('restaurant', {
            restaurant_id: state => state.id,
            locale: state => state.locale,
            f_modalita_fiera: state => state.f_modalita_fiera
        }),
        ...mapState('auth', {
            api_key: state => state.api_key
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        })
    },
    watch: {},
    methods: {
        fetch: function () {
            this.showLoading(true);
            getLv1(
                this.language, {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id
                },
                this.api_key
            ).then((configurazioni) => {
                this.showLoading(false);

                let address = null;
                if(configurazioni.delivery.f_modalita_fasce_zona){
                    address = this.curr_address
                }

                if (!address && configurazioni.delivery.indirizzo_predefinito) {
                    const indirizzoPredefinito =
                        configurazioni.delivery.indirizzo_predefinito;

                    if (configurazioni.delivery.tipo_modalita_zone === 'MANUALE') {
                        // Trovo la consegna citta
                        let consegnaCittaDelPredefinito = configurazioni.delivery
                            .consegne_citta
                            ? configurazioni.delivery.consegne_citta.find((consegnaCitta) => {
                                let cond1 =
                                    consegnaCitta.id ===
                                    indirizzoPredefinito.indirizzo.id_consegna_citta;

                                if (cond1 && consegnaCitta.zone && consegnaCitta.zone.length) {
                                    return (
                                        cond1 &&
                                        consegnaCitta.zone.find((zona) => {
                                            return (
                                                zona.id ===
                                                indirizzoPredefinito.indirizzo.id_consegna_zona
                                            );
                                        })
                                    );
                                } else {
                                    return cond1;
                                }
                            })
                            : null;

                        if (consegnaCittaDelPredefinito) {
                            let zoneEsistono = !!consegnaCittaDelPredefinito.zone.length;

                            address = {
                                tipo: configurazioni.delivery.tipo_modalita_zone,
                                id_consegna_citta:
                                indirizzoPredefinito.indirizzo.id_consegna_citta,
                                id_consegna_zona:
                                indirizzoPredefinito.indirizzo.id_consegna_zona,
                                zone_enabled: zoneEsistono,
                                completed: true,
                            };
                        }
                    } else if (configurazioni.delivery.tipo_modalita_zone === 'COORDINATE') {
                        address = {
                            tipo: configurazioni.delivery.tipo_modalita_zone,
                            formatted_address: indirizzoPredefinito.formatted_address,
                            lat: indirizzoPredefinito.indirizzo.latitudine,
                            lng: indirizzoPredefinito.indirizzo.longitudine,
                            numero_civico: indirizzoPredefinito.indirizzo.numero,
                            id_consegna_citta:
                            indirizzoPredefinito.indirizzo.id_consegna_citta,
                            info: {
                                indirizzo: indirizzoPredefinito.indirizzo.indirizzo,
                                numero: indirizzoPredefinito.indirizzo.numero,
                                localita_citta: indirizzoPredefinito.indirizzo.localita_citta,
                                cap_citta: indirizzoPredefinito.indirizzo.cap_citta,
                                provincia: indirizzoPredefinito.indirizzo.provincia,
                                nazione: indirizzoPredefinito.indirizzo.nazione,
                            },
                            completed: true,
                        };
                    }
                }

                if (this.order.type) {
                    let type = this.order.type.toLowerCase();
                    this.init_type = configurazioni[type].f_attivo ? type : null;
                } else {
                    const activeConfigurations = [];
                    for (let key in configurazioni) {
                        if (configurazioni.hasOwnProperty(key)) {
                            if (key === "prenotazioni") continue;

                            if (configurazioni[key].f_attivo) {
                                activeConfigurations.push(key);
                            }
                        }
                    }

                    if (activeConfigurations.length === 1) {
                        this.init_type = activeConfigurations[0];
                    }
                }
                this.conf_lv1 = configurazioni;
                this.curr_address = address;
            }).catch(() => {
                this.showLoading(false);
            });
        },
        loadLv2: function (type, params = {}) {
            this.showLoading(true);
            const {address, point, table, consegneCittaTrovate} = params;
            this.conf_lv2 = null;
            this.conf_lv3 = null;
            if (address && address !== this.curr_address) {
                this.curr_address = address;
            }
            if (point && point !== this.curr_point) {
                this.curr_point = point;
            }
            if (table && table !== this.curr_table) {
                this.curr_table = table;
            }

            let id_consegna_citta;
            let id_consegna_zona = null;

            if (consegneCittaTrovate && consegneCittaTrovate.length) {
                id_consegna_citta = consegneCittaTrovate;
            } else if(this.conf_lv1[type].f_modalita_fasce_zona && address){
                id_consegna_citta = address.consegneCittaTrovate && address.consegneCittaTrovate.length ?  address.consegneCittaTrovate : address.id_consegna_citta;

                id_consegna_zona =
                    this.conf_lv1[type].f_modalita_fasce_zona && address
                        ? address.id_consegna_zona
                        : null;
            }

            getLv2(
                this.language,
                {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id,
                    tipo: type,
                    id_consegna_citta,
                    id_consegna_zona,
                    id_punto_di_servizio: this.conf_lv1[type].f_modalita_fasce_zona
                        ? point
                        : null,
                },
                this.api_key,
            ).then((configurazioni) => {
                if (this.init_type) {
                    this.init_people_number = this.order.n_persone ? this.order.n_persone : null;
                    this.init_day = this.order.date
                        ? moment(this.order.date).format('YYYY-MM-DD')
                        : null;
                    this.init_time = this.order.date
                        ? moment(this.order.date).format('HH:mm')
                        : null;
                } else {
                    this.init_people_number = null;
                    this.init_day = null;
                    this.init_time = null;
                }

                this.conf_lv2 = configurazioni;
                if (!this.init_type) {
                    this.curr_asap = false;
                } else {
                    this.init_type = null;
                }
                this.showLoading(
                    !!configurazioni.giorni.length &&
                    (this.f_ponyu_fasce_delivery || this.f_eatintime_fasce_delivery) &&
                    ['delivery', 'dil'].includes(type)
                );
            }).catch((e) => {
                console.log(e);
                this.showLoading(false);
            });
        },
        loadLv3: function () {
            this.showLoading(true);
            this.conf_lv3 = null;

            getLv3(
                this.language,
                {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id,
                    tipo: this.curr_type,
                    id_consegna_citta: this.conf_lv1[this.curr_type].f_modalita_fasce_zona && this.curr_address && this.curr_address.id_consegna_citta ? this.curr_address.id_consegna_citta : '',
                    id_consegna_zona: this.conf_lv1[this.curr_type].f_modalita_fasce_zona && this.curr_address && this.curr_address.id_consegna_zona ? this.curr_address.id_consegna_zona : '',
                    data: this.curr_date,
                },
                this.api_key,
            ).then((configurazione) => {
                this.conf_lv3 = {
                    hours: configurazione.fasce,
                };
            }).catch(() => {
            }).finally(() => {
                this.showLoading(false);
            });
        },
        onLv1ButtonPress: function (type) {
            if (this.init_type || (type !== this.curr_type && !this.loading_visible)) {
                this.curr_type = type;
                this.conf_lv2 = null;
                this.conf_lv3 = null;

                if (!this.conf_lv1[type].f_forza_blocco) {
                    switch (type) {
                        case 'delivery':
                            //se non ho modalità fasce zona carico subito lv2
                            if (!this.conf_lv1[type].f_modalita_fasce_zona || this.curr_address) {
                                this.loadLv2(type, {address: this.curr_address});
                            }
                            break;
                        case 'dil':
                            if (this.f_modalita_fiera || this.curr_point) {
                                this.loadLv2(type, {point: this.curr_point});
                            } else if (this.conf_lv1[type].punti_di_servizio.length === 1) {
                                this.loadLv2(type, {point: this.conf_lv1[type].punti_di_servizio[0].id});
                            }
                            break;
                        case 'ordina_tavolo':
                            if (this.curr_table) {
                                this.loadLv2(type, {table: this.curr_table});
                            }
                            break;
                        default:
                            this.loadLv2(type);
                            break;
                    }
                }
            }
        },
        onIndirizzoManualeCittaPicked: function (city) {
            if (city) {
                let zoneEsistono = !!city.zone.length;

                let address = {
                    tipo: this.conf_lv1.delivery.tipo_modalita_zone,
                    id_consegna_citta: city.id,
                    id_consegna_zona: null,
                    zone_enabled: zoneEsistono,
                    completed: !zoneEsistono,
                };

                if (address.completed) {
                    this.loadLv2(this.curr_type, {address});
                } else {
                    this.curr_address = address;
                    this.conf_lv2 = null;
                    this.conf_lv3 = null;
                }
            } else {
                this.curr_address = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onIndirizzoManualeZonaPicked: function (zona) {
            if (zona) {
                if (zona.id !== (this.curr_address ? this.curr_address.id_consegna_zona : null)) {
                    let address = Object.assign({}, this.curr_address, {
                        id_consegna_zona: zona.id,
                        completed: true,
                    });

                    this.loadLv2(this.curr_type, {address});
                }
            } else {
                this.curr_address.id_consegna_zona = null;
                this.curr_address.completed = false;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onIndirizzoCoordinatePicked: function (geocodeResult, formattedAddress, houseNumber) {
            let consegneCittaTrovate = trovaConsegneCitta(
                this.conf_lv1.delivery.consegne_citta,
                geocodeResult.geometry.location.lng,
                geocodeResult.geometry.location.lat,
            ).sort((a, b) => {
                return a.area - b.area;
            }).map(({consegnaCitta}) => consegnaCitta.id);

            let address_components = geocodeResult.address_components;

            let indirizzo = address_components.find((address_component) => {
                return address_component.types.includes('route');
            });
            let localita_citta = address_components.find((address_component) => {
                return address_component.types.includes('administrative_area_level_3');
            })
            let cap_citta = address_components.find((address_component) => {
                return address_component.types.includes('postal_code');
            });
            let provincia = address_components.find((address_component) => {
                return address_component.types.includes('administrative_area_level_2');
            });
            let nazione = address_components.find((address_component) => {
                return address_component.types.includes('country');
            });

            let address = {
                tipo: this.conf_lv1.delivery.tipo_modalita_zone,
                formatted_address: formattedAddress,
                lat: geocodeResult.geometry.location.lat,
                lng: geocodeResult.geometry.location.lng,
                numero_civico: houseNumber,
                id_consegna_citta: null, //settato a null perchè sarà popolato quando verrà scelta la fascia oraria
                id_consegna_zona: null,
                info: {
                    indirizzo: indirizzo ? indirizzo.long_name : null,
                    numero: houseNumber,
                    localita_citta: localita_citta ? localita_citta.long_name : null,
                    cap_citta: cap_citta ? cap_citta.long_name : null,
                    provincia: provincia ? provincia.short_name : null,
                    nazione: nazione ? nazione.short_name : null,
                },
                completed: true,
                consegneCittaTrovate
            };

            this.loadLv2(this.curr_type, {address, consegneCittaTrovate});
        },
        onPointPicked: function (point) {
            if (point) {
                if (point !== this.curr_point) {
                    this.loadLv2(this.curr_type, {point});
                }
            } else {
                this.curr_point = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onQrCodeDecoded: function (table) {
            if (table) {
                if (table !== this.curr_table) {
                    this.loadLv2(this.curr_type, {table});
                }
            } else {
                this.curr_table = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onQrCodeScanAgain: function () {
            this.curr_table = null;
            this.conf_lv2 = null;
            this.conf_lv3 = null;
        },
        onPeopleNumberChange: function (value) {
            this.curr_people_number = value;
        },
        onDayChange: function (value, refinedValue) {
            this.curr_date = refinedValue;
            if (['delivery', 'dil'].includes(this.curr_type) && (this.f_ponyu_fasce_delivery || this.f_eatintime_fasce_delivery)) {
                this.loadLv3();
            } else {
                this.conf_lv3 = value;
            }
        },
        onTimeChange: function (time) {
            this.init_time = null;
            this.curr_time = time;

            if (['delivery'].includes(this.curr_type) && this.conf_lv1.delivery.f_modalita_fasce_zona && this.curr_address.lat){
                this.curr_address.id_consegna_citta = trovaConsegnaCitta(this.conf_lv1.delivery.consegne_citta.filter(consegna_citta => time.ids_consegna_citta.includes(consegna_citta.id)), this.curr_address.lng, this.curr_address.lat).id;
            }
        },
        onAsapChange: function (value) {
            this.curr_asap = value;
        },
        onModalClose: function (success) {
            this.show_confirm_modal = false;
            if (success) this.goOn();
        },
        goOn: function () {
            this.resetOrderTimers();
            this.setOrderOptions({
                type: this.curr_type.toUpperCase(),
                date: this.curr_date + ' ' + this.curr_time.from + ':00',
                id_menu: this.curr_time.id_menu,
                id_orario: this.curr_time.id_orario,
                f_appena_possibile: ['delivery', 'dil'].includes(this.curr_type) ? this.curr_asap : false,
                n_persone: ['mangia_ristorante', 'ordina_tavolo'].includes(this.curr_type) ? this.curr_people_number : null,
                fine_fascia: ['delivery', 'dil'].includes(this.curr_type) ? this.curr_time.to + ':00' : null,
                id_locale: this.locale.id,
                address: this.curr_type === 'delivery' ? this.curr_address : null,
                id_punto_di_servizio: this.curr_type === 'dil' ? this.curr_point : null,
                label_tipologia: this.conf_lv1[this.curr_type]?.label_tipologia,
                table: this.curr_type === 'ordina_tavolo' ? this.curr_table : null
            });

            if (this.order.items.length) {
                this.replaceOrderItems(
                    getSurvivedItems(
                        this.order.items,
                        this.curr_type.toUpperCase(),
                        this.curr_time.id_menu
                    )
                );
            }

            this.$router.push({name: 'menu.categories'});
        },
        onSeeMenuTap: function () {
            const confirmTrigger = ['MANGIA_RISTORANTE', 'ORDINA_TAVOLO'];

            console.log(this.curr_type, this.order.type);
            if (
                this.order.total_items &&
                ((confirmTrigger.includes(this.curr_type.toUpperCase()) &&
                        !confirmTrigger.includes(this.order.type.toUpperCase())) ||
                    (confirmTrigger.includes(this.order.type.toUpperCase()) &&
                        !confirmTrigger.includes(this.curr_type.toUpperCase())))
            ) {
                this.show_confirm_modal = true;
            } else {
                this.goOn();
            }

        },
        ...mapActions('global', {
            showLoading: 'showLoading'
        }),
        ...mapActions('order', {
            setOrderOptions: 'setOptions',
            replaceOrderItems: 'replaceItems',
            resetOrderTimers: 'resetTimers',
        })
    }
}
</script>
